$(function() {
  var tableBranch;

  tableBranch = $('#branches_datatable').dataTable({
    processing: true,
    serverSide: true,
    ajax: {
      url: $('#branches_datatable').data('source'),
      contentType: "application/json",
      type: "POST",
      data: function(d) {
        return JSON.stringify(d);
      }
    },
    pagingType: "full_numbers",
    columns: [
      {data: "name"},
      {data: "phone"},
      {data: "address"},
      {data: "city"},
      {data: "action"}
    ], order: [0, "asc"]
    // pagingType is optional, if you want full pagination controls.
    // Check dataTables documentation to learn more about
    // available options.
  });

  $('#branches_datatable_filter input').unbind();
  $('#branches_datatable_filter input').bind('keyup', function(e) {
    if (e.keyCode === 13) {
      tableBranch.fnFilter(this.value);
    }
  });

  window.filterBranch = function() {
    tableBranch.fnFilter("");
  }
});